<div class="page">
  <section class="hero" aria-labelledby="articlesTitle"
           [style.--hero-cover]="cover(header().coverBg.large)"
           [style.--hero-cover-preview]="cover(header().coverBg.small)">
    <h1 class="hero__title" id="articlesTitle">{{ header().title }}</h1>
    <p class="hero__desc" [innerHTML]="header().description"></p>
    @if (canCreate) {
      <div class="hero__actions">
        <a class="ut-btn" uiSref="newarticle" (click)="checkLightTester($event)">
          <span class="material-icons" aria-hidden="true">edit</span>
          Write an article
        </a>
      </div>
    }
  </section>

  <div class="tabs" role="group" aria-label="Article lists">
    @for (option of tabs; track option.value) {
      <button
        type="button"
        class="tab"
        [class.is-active]="tab() === option.value"
        [attr.aria-pressed]="tab() === option.value"
        (click)="selectTab(option.value)">
        {{ option.label }}
      </button>
    }
  </div>

  <p class="sr-only" role="status">{{ announcement() }}</p>

  @if (cards.length) {
    <div class="feed" [attr.aria-busy]="store.isLoading">
      @for (article of cards; track article.id) {
        <ut-community-feed-item [id]="'article_' + article.id" [item]="article" [user]="user || {}"></ut-community-feed-item>
      }
    </div>
  } @else if (store.isLoading) {
    <div class="feed" aria-hidden="true">
      <div class="skeleton"></div>
      <div class="skeleton"></div>
      <div class="skeleton"></div>
    </div>
  } @else if (store.hasFailed) {
    <div class="alert alert--error" role="alert">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <p class="alert__text"><b>Articles couldn't load.</b> Check your connection and try again.</p>
      <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="retry()">Retry</button>
    </div>
  } @else {
    <div class="card empty">
      <span class="empty__icon" aria-hidden="true"><span class="material-icons">description</span></span>
      <p class="empty__title">No articles yet</p>
    </div>
  }

  @if (store.feedItems.length && store.hasFailed && !store.isLoading) {
    <div class="alert alert--error" role="alert">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <p class="alert__text"><b>More articles couldn't load.</b> Check your connection and try again.</p>
    </div>
  }

  @if (store.feedItems.length && !store.isLastPage) {
    <button type="button" class="ut-btn ut-btn--secondary more" [disabled]="store.isLoading" (click)="loadMore()">
      {{ store.isLoading ? 'Loading…' : store.hasFailed ? 'Retry' : 'Load more' }}
    </button>
  }
</div>
